/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// Gsap
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import AppMenu from './app/components/AppMenu/AppMenu';
import eslang from './app/lang/es.json';
import enlang from './app/lang/en.json';
import { useSelector } from 'react-redux';
import SceneController from './app/components/scenes/sceneController/SceneController';
import ScrollDown from './app/components/ScrollDown/ScrollDown';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// Language
const es = eslang;
const en = enlang;

function App() {
  const newCurrentScene = useSelector(
    (state) => state.sceneController.newCurrentScene
  );

  const lang = useSelector((state) => state.sceneController.lang);

  return (
    <div
      className={(newCurrentScene - 1) % 2 ? 'app bg-white dark-mode' : 'app'}
    >
      <AppMenu data={lang == 'ESP' ? es.menu : en.menu} />
      <div className="scroll">
        <SceneController />
      </div>
      <ScrollDown />
    </div>
  );
}

export default App;
